import React, { Component } from 'react';
import BackgroundSlideshow from 'react-background-slideshow'
import image1 from './8900_LivingRoom.jpg';
import image2 from './GalleryPhotos/8900_Front2.jpg';
import image3 from './435_Front.jpg';
import image4 from './435_DiningRoom.jpg';


class BackgroundSection extends Component {
  constructor(props){
    super();
    this.picLimit = this.picLimit.bind(this)
    this.state = {
      pictureCounter: 0,
      imgUrl: props.imageUrl[0]
    }
  }
  componentDidMount(){
    var t = this, p = this.props, s = this.state;

    var counter = 0;
    // var stateChange = () => {
    //   t.setState({
    //     imgUrl: p.imageUrl[counter],
    //     pictureCounter: t.picLimit(counter)
    //   })
    //   counter = t.picLimit(counter);
    // }
    // setInterval(stateChange.bind(this), 4000)
  }
  picLimit(x){
    if(x !== 3){
      return x + 1;
    }else{
      return 0;
    }
  }
  render(){
    var s = this.state;
    var dynamicStyle = {};
    var p = this.props, roc = p.rateOfChange || 0.2, start = p.start || (window.innerHeight * p.reactKey * -(roc))
    var imgPositionY = Math.ceil(start + (p.scrollHeight * roc))
    if(p.noFilter){var filterBackground = 'rgba(0, 0, 0, 0.0)'} else { var filterBackground = 'linear-gradient(#0000005c, #00000012, transparent, transparent, transparent, transparent, transparent, transparent, transparent, transparent)'}
    var borderBottom = 'none'
    if (this.props.name === "jumbotron")  borderBottom = '1px solid white'
    return (
      <div className="background-filter-after test" id={p.name} style={{borderBottom: borderBottom, position: 'relative', backgroundColor: 'black', backgroundPositionY: imgPositionY, ...style.frame}}>
      {/* <BackgroundSlideshow animationDelay={4500} images={[ image1, image2, image3, image4 ]} /> */}
        <div className="crossfade">
          <figure style={{margin: '0px'}}></figure>
          <figure style={{margin: '0px'}}></figure>
          <figure style={{margin: '0px'}}></figure>
          <figure style={{margin: '0px'}}></figure>
        </div>
        <div style={{width: '100%', height: '100%', background: filterBackground}}>
          {p.children}
        </div>
      </div>
    )
  }
}

export default BackgroundSection;

var style = {
  frame: {
    height: '100vh',
    width: '100%',
    backgroundSize: 'cover',
    willChange: 'scroll-position',
    backgroundPositionX: '50%',
    backgroundRepeat: 'no-repeat',
    zIndex: -5
  }
}



// WEBPACK FOOTER //
// ./src/BackgroundSection.js